<script>
import useTools from "@/use/Tools";
import useSharedData from "@/use/SharedData";
import {useSecurityStore} from "@/stores/Security";
import {useDefaultPaySectionStore} from "@/stores/DefaultPaySection.js";
import {onMounted, ref} from "vue";
import axios from "axios";

export default {
    setup() {
        const {$i18n, $router} = useTools();

        const {loading, total} = useSharedData();

        const securityStore = useSecurityStore();
        const defaultPaySectionStore = useDefaultPaySectionStore();


        const search = ref(null);

        const headers = [
            {
                text: "...",
                align: "start",
                sortable: false,
                value: "action",
                width: "0%",
            },
            {
                text: $i18n.t("common.code"),
                align: "start",
                sortable: true,
                value: "paySectionCode",
                width: "0%",
            },
            {
                text: $i18n.t("common.label"),
                align: "start",
                sortable: true,
                value: "paySectionLabel",
            },
        ];

        const actions = [
            {
                title: $i18n.t("common.edit"),
                icon: 'mdi-pencil-box-multiple',
                color: 'orange',
                access: () => securityStore.authorities['UPDATE_PAY_SLIP_PARAM'],
                disabled: () => false,
                func: (item) => {
                    $router.push({name: 'default_pay_sections.edit', params: { id: item.id }})
                },
            },
            {
                title: $i18n.t("common.delete"),
                icon: 'mdi-trash-can',
                color: 'red',
                access: () => securityStore.authorities['UPDATE_PAY_SLIP_PARAM'],
                disabled: () => false,
                func: (item) => {
                    $router.push({name: 'default_pay_sections.delete', params: { id: item.id }})
                },
            },
        ];

        function findAll() {
            loading.value = true;
            axios.get('/defaultPaySections').then((response) => {
                defaultPaySectionStore.setDefaultPaySections(response.data);
                total.value = response.data.length;
            }).finally(() => {
                loading.value = false;
            });
        }

        function view(item) {
            $router.push({name: "default_pay_sections.view", params: {id: item.id}});
        }

        onMounted(() => findAll());

        return {
            securityStore,
            defaultPaySectionStore,
            total,
            loading,
            headers,
            actions,
            search,
            view,
            findAll,
        }
    },
};
</script>

<template>
    <div>
        <w-app
            :title="$t('module.default_pay_section')"
            :total="total"
        >
            <template v-slot:rightToolbar>
                <w-btn-reload
                    :loading="loading"
                    @press="findAll"
                />
                <w-btn-add
                    :show="securityStore.authorities['UPDATE_PAY_SLIP_PARAM']"
                    @press="$router.push({ name: 'default_pay_sections.add' })"
                />
            </template>
            <template v-slot:content>
                <v-container fluid>
                    <v-row dense>
                        <v-col cols="4">
                            <w-text-field
                                v-model="search"
                                :label="$t('common.search')"
                            />
                        </v-col>
                    </v-row>
                </v-container>
                <w-data-table
                    :headers="headers"
                    :actions="actions"
                    :search="search"
                    :items="defaultPaySectionStore.defaultPaySections"
                    :total="total"
                    sort-by="paySectionOrder"
                    @rowDbClick="view"
                >
                    <template v-slot:[`item.paySectionCode`]="{ item }">
                        <w-chip :text="item.paySectionCode"/>
                    </template>
                    <template v-slot:[`item.paySectionLabel`]="{ item }">
                        <w-inline-text bold :text="item.paySectionLabel"/>
                    </template>
                </w-data-table>
            </template>
        </w-app>
        <router-view/>
    </div>
</template>